import { Services } from '@sigma-frontend-libs/commons'

import { generateServices, getSocket, permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'Tasks',

  mixins: [
    generateServices({
      name: Services.sendingsModeration,

      find: {
        defaultPagination: {
          limit: 100
        }
      },

      get: false,
      create: false,
      update: false,
      remove: false
    })
  ],

  data() {
    return {
      task: {},
      showDialog: false
    }
  },

  mounted() {
    if (this.checkPermissions(`advanced.${Services.sendingsModeration}.get`, permissionPresets.true)) {
      this.rest[Services.sendingsModeration].find()
    }

    const socket = getSocket()
    socket?.on(`${Services.sendingsModeration}.tasks.updated`, task => {
      const index = this.restData[Services.sendingsModeration].find.data.findIndex(item => {
        return item.id === task.id
      })
      if (index !== -1) {
        this.restData[Services.sendingsModeration].find.data.splice(index, 1, task)
      }
    })
  },

  render
}
